const MIN_DISPLAY_PERCENTAGE = 0;

export function getDesktopLiveStreamSafeFramingScale(displayPercentage: number | null | undefined): number | null {
  if (typeof displayPercentage !== 'number' || displayPercentage >= 1 || displayPercentage <= MIN_DISPLAY_PERCENTAGE) {
    return null;
  }
  return 1 / displayPercentage;
}
